<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1000px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group
              horizontal
              name="status"
              :label="$t('attributes.situation_remind')"
            >
              <b-switch v-model="form.deep_style" name="deep_style"></b-switch>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="situation_action"
              :label="$t('attributes.situation_action')"
            >
              <b-select v-model="form.action" name="action">
                <option value="A">
                  {{ $t('attributes.situation_action_a') }}
                </option>
                <option value="B">
                  {{ $t('attributes.situation_action_b') }}
                </option>
              </b-select>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ this.event.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'EventForm',

  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,

      form: this.extractFormValues(this.event),

      sortOptions: [...Array(20).keys()].map(i => i + 1)
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(500) },
      sort: { required },
      status: { required },
      action: { required, maxLength: maxLength(20) },
      deep_style: { required }
    }
  },
  computed: {
    formTitle() {
      let title = this.event.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.situation')

      return title
    }
  },
  watch: {
    event(newEvent) {
      this.form = this.extractFormValues(newEvent)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        sort: data.sort,
        status: data.status,
        action: data.action,
        deep_style: data.deep_style
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
